<template>
<modal :show="show">
    <div class="modal-header">
        <h4 class="modal-title">Update Payment</h4>
        <button @click="show=false" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="icon icon-close"></i>
        </button>
    </div>
    <div class="modal-body p-4 overflow-auto">
        <PaymentForm @submit="submit" @paypal="paypalClick" ref="payment"></PaymentForm>
    </div>
</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
import PaymentForm from "@/../submodules/vue-base/components/PaymentForm";
import CreditCardType from "@/mixins/CreditCardType";
import axios from "axios";
export default {

    name: 'UpdatePaymentModal',

    components: {
        Modal,
        PaymentForm
    },

    mixins: [
        CreditCardType
    ],

    data() {
        return {
            show: false,

        }
    },

    methods: {
        open() {
            this.show = true;
        },

        close() {
            this.show = false
        },

		paypalClick(){
			this.$emit("paypal");
            this.close();
		},

        submit() {

            this.$emit("submit", this.$refs.payment.paymentInfo);
            this.close();
        }
    }

}
</script>
